export default "__VITE_ASSET__DZOa5QY$__"